import { AnalyticsTypes } from '../../middleware/google-analytics';
import { LOCATION_CARD_KEY } from './constants';
import { EVENT_INITIATORS, INTERACTION_TYPES, TARGETS } from '../../EventTrackingConstants';
import { PROFILE_GA_CATEGORY } from '../../profile/ActiveProfile/constants';

export const ActionTypes = {
    TRACK_CLICK_I_BUBBLE_WHEELCHAIR_ACCESSIBLE: `${LOCATION_CARD_KEY}/TRACK_CLICK_I_BUBBLE_WHEELCHAIR_ACCESSIBLE`,
    TRACK_CLICK_I_BUBBLE_HANDICAP_ACCESSIBLE: `${LOCATION_CARD_KEY}/TRACK_CLICK_I_BUBBLE_WHEELCHAIR_ACCESSIBLE`,
    TRACK_CLICK_I_BUBBLE_PATIENT_AGE_RESTRICTION: `${LOCATION_CARD_KEY}/TRACK_CLICK_I_BUBBLE_PATIENT_AGE_RESTRICTION`,
    TRACK_CLICK_I_BUBBLE_TIER: `${LOCATION_CARD_KEY}/TRACK_CLICK_I_BUBBLE_TIER`,
    TRACK_CLICK_I_BUBBLE_PROVEN_HEALTH_NAVIGATOR_LOCATION: `${LOCATION_CARD_KEY}/TRACK_CLICK_I_BUBBLE_PROVEN_HEALTH_NAVIGATOR_LOCATION`,
    TRACK_CLICK_I_BUBBLE_GEISINGER_HEALTH_PLAN_EXTRA: `${LOCATION_CARD_KEY}/TRACK_CLICK_I_BUBBLE_GEISINGER_HEALTH_PLAN_EXTRA`,
    TRACK_CLICK_I_BUBBLE_ACCEPTING_NEW_PATIENTS: `${LOCATION_CARD_KEY}/TRACK_CLICK_I_BUBBLE_ACCEPTING_NEW_PATIENTS`,
};

export const trackClickIBubbleWheelchairAccessible = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_WHEELCHAIR_ACCESSIBLE,
        action: 'Click I Bubble Wheelchair Accessible',
        eventAction: 'click wheelchair accessible',
    });
};

export const trackClickIBubbleHandicapAccessible = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_HANDICAP_ACCESSIBLE,
        action: 'Click I Bubble Handicap Accessible',
        eventAction: 'click handicap accessible',
    });
};

export const trackClickIBubblePatientAgeRestrictions = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_PATIENT_AGE_RESTRICTION,
        action: 'Click I Bubble Patient Age Restriction',
        eventAction: 'click patient age restriction',
    });
};

export const trackClickIBubbleTier = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_TIER,
        action: 'Click I Bubble Tier',
        eventAction: 'click tier',
    });
};

export const trackClickIBubbleProvenHealthNavigatorLocation = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_PROVEN_HEALTH_NAVIGATOR_LOCATION,
        action: 'Click I Bubble Proven Health Navigator Location',
        eventAction: 'click proven health navigator location',
    });
};

export const trackClickIBubbleGeisingerHealthPlanExtra = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_GEISINGER_HEALTH_PLAN_EXTRA,
        action: 'Click I Bubble Geisinger Health Plan Extra',
        eventAction: 'click geisinger health plan extra',
    });
};

export const trackClickIBubbleAcceptingNewPatients = () => {
    return generateIBubbleTrackingEvent({
        type: ActionTypes.TRACK_CLICK_I_BUBBLE_ACCEPTING_NEW_PATIENTS,
        action: 'Click I Bubble Accepting New Patients',
        eventAction: 'click accepting new patients',
    });
};

const generateIBubbleTrackingEvent = ({ type, action, eventAction }) => ({
    type,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action,
            category: PROFILE_GA_CATEGORY,
            data: {
                Section: TARGETS.PROFILE,
                Component: TARGETS.I_BUBBLE,
                InteractionType: INTERACTION_TYPES.CLICK,
                Element: TARGETS.I_BUBBLE,
                Initiator: EVENT_INITIATORS.USER,
                EventAction: eventAction,
            },
        },
    },
});
